import script from "./multiselect.vue?vue&type=script&setup=true&lang=js"
export * from "./multiselect.vue?vue&type=script&setup=true&lang=js"

import "./multiselect.vue?vue&type=style&index=0&id=49fb6145&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49fb6145"]])

export default __exports__